import { ApisauceInstance } from 'apisauce';

const getDriverOverrides = ({
  api,
  bonusDatasetRecordId,
}: {
  api: ApisauceInstance;
  bonusDatasetRecordId: string;
}) => {
  return api.get<BonusTypes.Overrides.Persisted>(
    `/v1/driver_bonus/overrides?bonus_dataset_record_id=${bonusDatasetRecordId}`,
  );
};

export default getDriverOverrides;
